/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

export const PageHeading = styled.h1`
  font-family: "IBM Plex Mono";
  font-size: 20px;
  /* line-height: 20px; */
  font-weight: 500;
  margin-right: 20px;
  white-space: nowrap;
  overflow: hidden;
  display: flex;
  flex-direction: "row";
  align-items: center;
  color: ${({ theme }) => theme.text.default};
`;

export const Mono = styled.span`
  font-family: "IBM Plex Mono";
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
`;
